module.exports = __webpack_public_path__ + "static/media/P19.1b9567d4.jpg";